__turbopack_context__.v({
  "page": "studies-client-module__MQ8V3W__page",
});
